import { Heading, Text } from "@/design-system";
import { CheckCircle2 } from "lucide-react";
import { BENEFITS } from "../constants";
import { PageSection } from "@/pages/landingPage/components/pageSection";

export const BenefitsSection = () => (
  <PageSection labelledBy="beneficios-title">
    <Heading level={2} id="beneficios-title" className="mb-8 lg:mb-10">
      Por que cobrar pelo WhatsApp no varejo
    </Heading>

    <ul className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-x-10">
      {BENEFITS.map(benefit => (
        <li key={benefit} className="flex items-start gap-3">
          <CheckCircle2
            aria-hidden="true"
            className="text-ds-brand-600 mt-0.5 size-6 shrink-0"
          />
          <Text size="lead" tone="muted">
            {benefit}
          </Text>
        </li>
      ))}
    </ul>
  </PageSection>
);
